<template>
  <div :class="`${need_show_tutorial ? 'w-100 tutorial-form' : 'w-100'}`">
    <div class="row">
      <div class="col-6">
        <z-form ref="form">
          <!-- <div v-if="is_creating_loading">Loader</div> -->
          <!-- <base-form v-else :campaign="campaign" @input="set_data" /> -->
          <base-form
            :campaign="campaign"
            :need_show_tutorial="need_show_tutorial"
            :counter="counter"
            :tutorial_steps="tutorial_steps"
            @input="set_data"
            @input_empty_media_file="set_empty_media_file"
            @input_is_scheme_exist="set_is_scheme_exist"
            @set_numbers="set_numbers"
            @forward="forward_tutorial"
            @backward="backward_tutorial"
            @close="close_tutorial"
          />
        </z-form>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div
          :class="`${tutorial_steps[counter].id === 'ok' ? `hint hint--${counter}` : ''}`"
          :title="tutorial_steps[counter].text"
        >
          <i-button :loading="loading" type="primary" size="large" @click="send">
            {{ $t('shared.component.button.save') }}
          </i-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { CampaignsService } from '@autoinformer/services/CampaignsService';
  import BaseForm from '@autoinformer/components/campaigns-base-form';

  const getWeekday = (day) => {
    var days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    return days.indexOf(day);
  };

  const getWorktime = (worktime) => {
    if (worktime.length > 0) {
      return worktime.map((time) => ({
        start: time.start.length > 5 ? time.start.slice(0, -3) : time.start,
        end: time.end.length > 5 ? time.end.slice(0, -3) : time.end,
        day: typeof time.day === 'string' ? getWeekday(time.day) : time.day
      }));
    } else {
      return null;
    }
  };

  export default {
    components: {
      BaseForm
    },
    props: {
      id: {
        type: [Number, String],
        default: null
      },
      item: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      need_show_tutorial: false,
      counter: 3,
      tutorial_steps: [
        { id: 'name', text: 'Придумайте название кампании' },
        { id: 'caller_id', text: 'Выберите номер, который отобразится на телефоне клиента' },
        {
          id: 'scheme',
          text: 'Создайте собственную схему маршрутизацию звонка'
        },
        {
          id: 'ok',
          text: 'Кампания готова. Осталось только добавить номера для прозвона. Нажмите “Сохранить”'
        }
      ],
      loading: false,
      form: {},
      campaign: {},
      is_loading: true,
      is_creating_loading: true,
      empty_media_file: false,
      is_scheme_exist: false
    }),
    watch: {
      item: {
        handler: function (item) {
          this.campaign = item;
        },
        immediate: true
      }
    },

    created() {
      this.need_show_tutorial = !!this.$route.params?.tutorial;
    },

    methods: {
      set_data(data) {
        this.form = data;
      },
      set_empty_media_file(value) {
        this.empty_media_file = value;
      },
      set_is_scheme_exist(value) {
        this.is_scheme_exist = value;

      },
      set_numbers(list) {
        this.numbers = list?.map((item) => item.number);
      },
      backward_tutorial() {
        this.counter -= 1;
      },
      forward_tutorial() {
        if (this.counter < this.tutorial_steps.length) {
          this.counter += 1;
        }
      },
      close_tutorial() {
        this.need_show_tutorial = false;
      },
      get_callers_filter_params(callers) {
        if (callers.find((i) => i === 'all')) {
          // вернуть все номера
          return this.numbers.filter((item) => item !== 'all');
        } else if (callers.length) {
          return callers.filter((item) => item !== 'all');
        } else {
          return undefined;
        }
      },
      send() {
        this.$refs.form.validate().then((is_valid) => {

          if(this.empty_media_file && this.is_scheme_exist) {
            this.$noty.warning(this.$t('autoinformer.validator.empty_mediafiles'), {
              timeout: 5000,
              maxVisible : 1,
              layout: 'bottomCenter',
              animation: {
                open : 'animated fadeInUp',
                close : 'animated fadeOutDown',
              }
            });
            return;
          }

          if (is_valid) {
            this.loading = true;

            this.form.strategy = this.form.strategy?.map((val) => (val === null ? (val = 1) : val));

            const fields = this.form;

            const data = {
              name: fields.name,
              callers: this.get_callers_filter_params(fields.callers),
              strategy: fields.strategy.length > 0 ? fields.strategy : [],
              call_limit: fields.call_limit,
              timezone: fields.timezone,
              worktime: getWorktime(fields.modify_work_time),
              dial_timeout: fields.dial_timeout,
              need_amd: fields.need_amd,
            };

            localStorage.removeItem('autoinformer_form');

            CampaignsService.editItem(this.campaign.id, data)
              .then(() => {
                this.$router.push({
                  name: 'autoinformer.campaign.index',
                  params: {
                    tutorial: this.need_show_tutorial,
                    counter: this.need_show_tutorial ? 1 : undefined
                  }
                });
              })
              .catch((error) => {
                this.$noty.server_error(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
      }
    }
  };
</script>
